var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuLibraryDetailMenuNameIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 25.6 24.8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9455 0L15.1273 6.04878V19.3561L20.9455 13.9122V0ZM0 6.04878V23.7717C0 24.0741 0.290909 24.3766 0.581818 24.3766C0.698182 24.3766 0.756364 24.3161 0.872727 24.3161C2.44364 23.5298 4.71273 22.9854 6.4 22.9854C8.66909 22.9854 11.1127 23.4693 12.8 24.8V6.04878C11.1127 4.71805 8.66909 4.23415 6.4 4.23415C4.13091 4.23415 1.68727 4.71805 0 6.04878ZM25.6 22.3805V6.04878C24.9018 5.50439 24.1455 5.14146 23.2727 4.83902V21.1707C21.9927 20.7473 20.5964 20.5659 19.2 20.5659C17.2218 20.5659 14.3709 21.3522 12.8 22.3805V24.8C14.3709 23.7717 17.2218 22.9854 19.2 22.9854C21.12 22.9854 23.0982 23.3483 24.7273 24.2556C24.8436 24.3161 24.9018 24.3161 25.0182 24.3161C25.3091 24.3161 25.6 24.0137 25.6 23.7112V22.3805Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuLibraryDetailMenuNameIcon);
export default __webpack_public_path__ + "static/media/menu_library_detail_menu_name_icon.1be30f08f491d64cff046c39c4d4fcf2.svg";
export { ForwardRef as ReactComponent };